import Icon from 'vue-awesome/components/Icon'

Icon.register({
  network_locked_sharp: {
    paths: [
      {
        d: 'M22 16v-.36c0-1.31-.94-2.5-2.24-2.63A2.5 2.5 0 0017 15.5v.5h-1v6h7v-6h-1zm-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.5z'
      },
      {
        d: 'M19.5 11c.15 0 .3.01.46.02.01 0 .03.01.04.01V1L1 20h13v-6h1.26c.22-.63.58-1.2 1.06-1.68.85-.85 1.98-1.32 3.18-1.32z'
      }
    ],
    width: '24',
    height: '24'
  }
})
